/** zh-CN catalogue `persist` (W3-09; English: src/persist/persist.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'persist',
  locale: 'zh-CN',
  messages: {
    renameTxn: '将项目重命名为“{name}”',
  },
};

export default catalog;
